module.exports = __webpack_public_path__ + "media/images/badge-spotify-exporter-ec347e974f9bb7c047ef8b5dc7dd2a24.gif";